function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.384 3.378c0-.636.514-1.156 1.15-1.156h4.142c.306 0 .601.122.815.341l2.79 2.79c.22.215.341.51.341.815v6.454c0 .636-.52 1.156-1.155 1.156h-6.94c-.635 0-1.15-.52-1.15-1.156l.007-9.244zm5.194-.29v2.6c0 .319.26.579.578.579h2.6L8.578 3.089z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/file.34891007.svg";
export { SvgComponent as ReactComponent };